import React from 'react';
import { useRevealChildren } from '../../hooks/useRevealChildren';
import { advisoryMembers, advisoryMembersRow2 } from '../../data/advisoryMembers';
import AdvisoryCard from './AdvisoryCard';
import './AdvisoryBoard.css';

function AdvisoryBoard() {
  const ref = useRevealChildren();

  return (
    <section className="advisory-section" ref={ref}>
      <div className="container">
        <div className="section-header reveal">
          <div className="section-eyebrow">Leadership</div>
          <h2 className="section-title">Advisory Board Member</h2>
        </div>
        <div className="advisory-row">
          {advisoryMembers.map((m) => (
            <AdvisoryCard key={m.name} member={m} />
          ))}
        </div>
        <div className="advisory-row row-2">
          {advisoryMembersRow2.map((m) => (
            <AdvisoryCard key={m.name} member={m} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default AdvisoryBoard;
